import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import type { AccordionRootProps } from 'types';

type AccordionContextProps = AccordionRootProps | null;

const AccordionContext = createContext<AccordionContextProps>(null);

type AccordionContextProviderProps = PropsWithChildren<{
  value: AccordionContextProps;
}>;

export const AccordionProvider = ({
  children,
  value,
}: AccordionContextProviderProps) => {
  return (
    <AccordionContext.Provider value={value}>
      {children}
    </AccordionContext.Provider>
  );
};

export function useAccordionContext() {
  return useContext<AccordionContextProps>(AccordionContext);
}
